'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
// Create context with a default undefined value
const ModeContext = createContext(undefined);
export const ModeProvider = ({ children }) => {
    const [mode, setMode] = useState('inline');
    return _jsx(ModeContext.Provider, { value: { mode, setMode }, children: children });
};
// Custom hook for cleaner usage
export const useMode = () => {
    const context = useContext(ModeContext);
    if (!context) {
        throw new Error('useMode must be used inside ModeProvider');
    }
    return context;
};
